import { Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UserStatus } from '../../types/chat.types';

export const ChatStatusBadge = styled(Badge)<{ status?: UserStatus }>(({ theme, status }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: 
      status === 'online' 
        ? theme.palette.success.main 
        : status === 'away' 
        ? theme.palette.warning.main 
        : 'transparent',
    color: status === 'online' ? theme.palette.success.main : theme.palette.warning.main,
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: status === 'online' ? 'ripple 1.2s infinite ease-in-out' : 'none',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));
